<template>
  <div class="my-menu">
    <div class="wd">
      <Row class="my-list" type="flex" justify="space-around">
        <i-col class="my-item">
          <img src="@/assets/my/work.png" alt style="height: 488px;width: fit-content;"/>
          <a href="/static/scratch3/index.html?scene=create" target="_blank" class="btn btn4">自由创作</a>
        </i-col>
        <i-col>
          <div class="my-item">
            <img src="@/assets/my/w1.png" alt />
            <router-link to="/mycourse" class="btn btn1">我的课程</router-link>
          </div>
          <div class="my-item">
            <img src="@/assets/my/w2.png" alt />
            <router-link to="/mycenter" class="btn btn2">个人中心</router-link>
          </div>
          <div class="my-item">
            <img src="@/assets/my/w3.png" alt />
            <router-link to="/shopping" class="btn btn3">课程商城</router-link>
          </div>
        </i-col>
      </Row>
      <div class="course">
        <Carousel
          style="margin: 0 auto;width: 1100px;"
          :autoplay="false"
          dots="none"
          arrow="always"
        >
          <CarouselItem v-for="i in caroulLength" :key="i.id">
            <Row type="flex" justify="center">
              <i-col span="6" class="wrap-item" v-for="(item, index) in activityList.slice((i-1)*4, i*4)" :key="index">
                <img @click="toGoodsDetail(item.id)" :src="item.activityCoverFileUrl" @mouseover="isShowIndex = index" />
                <div
                  class="introduce"
                  v-show="isShowIndex === index"
                  @mouseleave="isShowIndex = ''"
                >
                <p @click="toGoodsDetail(item.id)">{{ item.activityName }}</p>
                <Row type="flex" justify="space-between">
                  <i-col span="10">￥{{ item.price / 100 }}元</i-col>
                  <i-col span="6" class="good">高级</i-col>
                </Row>
                <span @click="toGoodsDetail(item.id)">{{ item.activityDesc }}</span>
                  <!-- <Poptip width="240" height="280" :title="'微信扫一扫购买课程'">
                    <p>{{ item.activityName }}</p>
                    <Row type="flex" justify="space-between">
                      <i-col span="10">￥{{ item.price / 100 }}元</i-col>
                      <i-col span="6" class="good">高级</i-col>
                    </Row>
                    <span>{{ item.activityDesc }}</span>
                    <div class="bind-wechat" slot="content">
                      <qrcode-vue :value="getBuyLink(item.id)" :size="200" level="H"></qrcode-vue>
                    </div>
                  </Poptip> -->
                </div>
              </i-col>
            </Row>
          </CarouselItem>
        </Carousel>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from "@/api";
import { getActivityList, getBuyLink } from "@/api/buy";
// import QrcodeVue from "qrcode.vue";
export default {
  // components: {
  //   QrcodeVue,
  // },
  data() {
    return {
      isShowIndex: "",
      activityList: [],
      caroulLength: "1"
    };
  },
  created() {
    this.getUser();
    this.getActivityList();
  },
  methods: {
    getUser() {
      getUserInfo().then((res) => {
        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            activitiSync: 1,
            agentId: null,
            avatar:
              "user/20190220/e1fe9925bc315c60addea1b98eb1cb1349547719_1550656892940.jpg",
            birthday: "2020-04-12",
            createBy: "admin",
            createTime: "2019-02-13 16:02:36",
            delFlag: 0,
            departIds:
              "08c4eb18225e4c8f9178a38081a3eb64,eb1ed0b7e1eb44d7ab79a28cb4ea3a54",
            email: "858134843@qq.com",
            grade: null,
            id: "a75d45a015c44384a04449ee80dc3503",
            inviteWithdraw: 100,
            orgCode: "A01",
            phone: "17721211032",
            post: "",
            realname: "jeecg",
            school: null,
            sex: 1,
            sign: null,
            status: 1,
            telephone: null,
            thirdId: null,
            thirdType: null,
            updateBy: "jeecg",
            updateTime: "2020-06-20 19:36:36",
            userIdentity: 2,
            username: "jeecg",
            workNo: "001",
          })
        );
      });
    },
    getActivityList() {
      getActivityList("","","", "", 8).then((res) => {
        if (res.success) {
          this.activityList = res.result;
          this.caroulLength = Math.ceil(
            this.activityList.length / 4
          );
        }
      });
    },
    toGoodsDetail(actId){
      this.$router.push({
        path: `/goodsDetail?actId=${actId}`
      });
    }
    // getBuyLink(id) {
    //   return getBuyLink(id);
    // },
  },
};
</script>
<style lang="scss">
.my-menu {
  .ivu-carousel-arrow {
    background: url("../../assets/my/arrowbg.png");
    background-size: 100% 100%;
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
    &.right {
      right: -42px;
    }
    &.left {
      left: -43px;
    }
  }
}
</style>
<style lang="scss" scoped>
.my-menu {
  .my-list {
    width: 100%;
    padding-top: 80px;
    padding-bottom: 50px;
    .my-item {
      position: relative;
      margin-bottom: 30px;
      .btn {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-weight: 700;
        display: block;
        border-radius: 28px;

        font-size: 20px;
        text-align: center;
        width: 177px;
        height: 58px;
        line-height: 58px;
      }
      .btn1 {
        background: linear-gradient(
          270deg,
          rgb(151, 149, 240) 0%,
          rgb(251, 200, 212) 100%
        );
      }
      .btn2 {
        background: linear-gradient(
          90deg,
          rgb(163, 189, 237) 0%,
          rgb(105, 145, 199) 100%
        );
      }
      .btn3 {
        background: linear-gradient(
          270deg,
          rgb(247, 139, 159) 0%,
          rgb(251, 126, 141) 33%,
          rgb(254, 153, 139) 100%
        );
      }
      .btn4 {
        width: 224px;
        height: 74px;
        line-height: 74px;
        background: linear-gradient(
          90deg,
          rgb(163, 189, 237) 0%,
          rgb(105, 145, 199) 100%
        );
      }
    }
  }
  .course {
    width: 1203px;
    height: 230px;
    margin: 0 auto;
    border-radius: 8px;
    background-color: rgba(32, 48, 108, 0.407843137254902);
    padding-top: 40px;

    .wrap-item {
      position: relative;
      img {
        border-radius: 5px;
        width: 248px;
        height: 167px;
      }
      .introduce {
        border-radius: 5px;
        color: #fff;
        position: absolute;
        top: 0;
        left: 14px;
        width: 248px;
        height: 167px;
        background: rgba(0, 0, 0, 0.4);
        padding: 20px;
        p {
          font-size: 20px;
          font-weight: 700;
          padding: 10px 0;
        }
        .good {
          background: #39a5ef;
          font-size: 12px;
          padding: 0 10px;
          line-height: 20px;
          border-radius: 5px;
          margin-bottom: 15px;
        }
        span {
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/mymenu.vue